var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5445 3.77642L22.0432 11.2751C22.2037 11.4356 22.236 11.6936 22.1153 11.8944C19.6012 16.074 16.0669 19.6202 11.8834 22.1239C11.6892 22.2402 11.4408 22.2095 11.2808 22.0494L3.77017 14.5388C3.61013 14.3787 3.57941 14.1304 3.69565 13.9362C6.19942 9.7527 9.74557 6.21835 13.9252 3.70433C14.126 3.58354 14.384 3.61587 14.5445 3.77642Z",
    stroke: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4314 11.4432L22.7916 11.5712C22.5457 11.6204 22.2915 11.5434 22.1141 11.3661L14.4536 3.70557C14.2763 3.52825 14.1993 3.27405 14.2485 3.02815L14.3765 2.38835C14.4939 1.80096 15.2187 1.58153 15.6422 2.0051L23.8146 10.1775C24.2382 10.601 24.0187 11.3258 23.4314 11.4432Z",
    stroke: "#393939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4432 23.4315L11.5712 22.7917C11.6204 22.5458 11.5434 22.2916 11.3661 22.1143L3.70557 14.4537C3.52825 14.2764 3.27405 14.1995 3.02815 14.2486L2.38835 14.3766C1.80096 14.4941 1.58153 15.2188 2.0051 15.6424L10.1775 23.8147C10.601 24.2383 11.3258 24.0189 11.4432 23.4315Z",
    stroke: "#393939"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9097,
    cy: 12.9099,
    r: 3.55719,
    transform: "rotate(45 12.9097 12.9099)",
    stroke: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputs);
export default __webpack_public_path__ + "static/media/inputs.6acd11e0f9fa8b3dc767d61017b2667a.svg";
export { ForwardRef as ReactComponent };